/* Polar Plunge V4 shared behaviour. Loaded once, deferred.
   - Horizontal scrollers: [data-pp-scroller-root] wraps a [data-pp-scroller] track and optional
     [data-pp-scroller-prev] / [data-pp-scroller-next] buttons. Arrows hide when nothing overflows. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScroller(root) {
    if (root.__ppScroller) return;
    var track = root.querySelector('[data-pp-scroller]');
    if (!track) return;
    root.__ppScroller = true;
    var prev = root.querySelector('[data-pp-scroller-prev]');
    var next = root.querySelector('[data-pp-scroller-next]');
    var nav = root.querySelector('[data-pp-scroller-nav]');

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (nav) nav.hidden = max <= 0;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    root.__ppUpdate = update;
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pp-scroller-root]'), initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  function updateAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-pp-scroller-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__ppUpdate) root.__ppUpdate(); else initScroller(root);
    });
  }

  window.PP = window.PP || {};
  window.PP.initScrollers = initAll;
  window.PP.updateScrollers = updateAll;
})();
